import * as yup from 'yup';

const schemaFlowRequired = yup.object({
  value: yup.number().required().min(0),
  valueString: yup.number().required().min(0),
});

export { schemaFlowRequired };
